<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 17.4997L13.875 13.8747M4.57086 4.33691C3.29513 5.55131 2.5
      7.26596 2.5 9.16632C2.5 12.8482 5.48477 15.833 9.16667 15.833C12.2126 15.833 14.7814 13.7903 15.578 11"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <mask
      id="path-2-inside-1_9001_114691"
      fill="white"
    >
      <path
        d="M11.6455 4.1896C11.7438 3.89486 12.16 3.89486 12.2582
      4.1896L12.8343 5.91964C12.9611 6.29995 13.1747 6.64549 13.4583
      6.92889C13.7418 7.21228 14.0875 7.42573 14.4679 7.55233L16.197
      8.12841C16.4918 8.22666 16.4918 8.64287 16.197 8.74112L14.467
      9.3172C14.0867 9.44401 13.7411 9.65765 13.4577 9.9412C13.1744 10.2247
      12.9609 10.5704 12.8343 10.9508L12.2582 12.6799C12.237 12.7445 12.196
      12.8007 12.141 12.8405C12.086 12.8804 12.0198 12.9018 11.9519
      12.9018C11.8839 12.9018 11.8177 12.8804 11.7627 12.8405C11.7077
      12.8007 11.6667 12.7445 11.6455 12.6799L11.0694 10.9499C10.9427
      10.5697 10.7292 10.2242 10.4458 9.94081C10.1624 9.65742 9.81695
      9.44392 9.43674 9.3172L7.7067 8.74112C7.64216 8.71994 7.58596
      8.67891 7.54611 8.6239C7.50627 8.56888 7.48481 8.50269 7.48481
      8.43476C7.48481 8.36684 7.50627 8.30064 7.54611 8.24563C7.58596
      8.19062 7.64216 8.14959 7.7067 8.12841L9.43674 7.55233C9.81695
      7.42561 10.1624 7.21211 10.4458 6.92872C10.7292 6.64533 10.9427
      6.29985 11.0694 5.91964L11.6455 4.1896ZM8.20467 0.13289C8.21748
      0.0942114 8.24215 0.0605528 8.27518 0.0366966C8.30821 0.0128404
      8.34792 0 8.38866 0C8.42941 0 8.46912 0.0128404 8.50215 0.0366966C8.53518
      0.0605528 8.55985 0.0942114 8.57265 0.13289L8.91831 1.17074C9.07282
      1.63339 9.43544 1.99601 9.8981 2.15053L10.9359 2.49618C10.9746 2.50899
      11.0083 2.53366 11.0321 2.56669C11.056 2.59972 11.0688 2.63943 11.0688
      2.68017C11.0688 2.72091 11.056 2.76062 11.0321 2.79365C11.0083 2.82668
      10.9746 2.85135 10.9359 2.86416L9.8981 3.20981C9.66992 3.28583 9.46258
      3.41395 9.29251 3.58402C9.12245 3.75409 8.99433 3.96142 8.91831
      4.1896L8.57265 5.22745C8.55985 5.26613 8.53518 5.29979 8.50215
      5.32364C8.46912 5.3475 8.42941 5.36034 8.38866 5.36034C8.34792
      5.36034 8.30821 5.3475 8.27518 5.32364C8.24215 5.29979 8.21748
      5.26613 8.20467 5.22745L7.85902 4.1896C7.783 3.96142 7.65488 3.75409
      7.48481 3.58402C7.31475 3.41395 7.10741 3.28583 6.87923 3.20981L5.84139
      2.86416C5.80271 2.85135 5.76905 2.82668 5.74519 2.79365C5.72134 2.76062
      5.7085 2.72091 5.7085 2.68017C5.7085 2.63943 5.72134 2.59972 5.74519
      2.56669C5.76905 2.53366 5.80271 2.50899 5.84139 2.49618L6.87923
      2.15053C7.10741 2.07451 7.31475 1.94639 7.48481 1.77632C7.65488
      1.60625 7.783 1.39892 7.85902 1.17074L8.20467 0.13289ZM14.3902
      0.519201C14.399 0.493769 14.4156 0.471717 14.4375 0.45611C14.4594
      0.440502 14.4857 0.432116 14.5126 0.432116C14.5395 0.432116 14.5658
      0.440502 14.5877 0.45611C14.6096 0.471717 14.6261 0.493769 14.6349
      0.519201L14.8654 1.2105C14.9681 1.51953 15.2101 1.76158 15.5192
      1.86429L16.2105 2.09473C16.2359 2.10354 16.258 2.12006 16.2736
      2.14199C16.2892 2.16392 16.2976 2.19017 16.2976 2.21709C16.2976
      2.24401 16.2892 2.27025 16.2736 2.29218C16.258 2.31411 16.2359
      2.33063 16.2105 2.33945L15.5192 2.56989C15.3669 2.62055 15.2285
      2.70602 15.115 2.81951C15.0015 2.933 14.916 3.07138 14.8654
      3.22367L14.6349 3.91498C14.6261 3.94041 14.6096 3.96246 14.5877
      3.97807C14.5658 3.99367 14.5395 4.00206 14.5126 4.00206C14.4857
      4.00206 14.4594 3.99367 14.4375 3.97807C14.4156 3.96246 14.399
      3.94041 14.3902 3.91498L14.1598 3.22367C14.1091 3.07138 14.0237
      2.933 13.9102 2.81951C13.7967 2.70602 13.6583 2.62055 13.506 2.56989L12.8156
      2.33945C12.7902 2.33063 12.7681 2.31411 12.7525 2.29218C12.7369 2.27025 12.7285
      2.24401 12.7285 2.21709C12.7285 2.19017 12.7369 2.16392 12.7525 2.14199C12.7681
      2.12006 12.7902 2.10354 12.8156 2.09473L13.5069 1.86429C13.8159 1.76158 14.058
      1.51953 14.1607 1.2105L14.3902 0.519201Z"
      />
    </mask>
    <path
      d="M11.6455 4.1896C11.7438 3.89486 12.16 3.89486 12.2582 4.1896L12.8343 5.91964C12.9611
      6.29995 13.1747 6.64549 13.4583 6.92889C13.7418 7.21228 14.0875 7.42573 14.4679
      7.55233L16.197 8.12841C16.4918 8.22666 16.4918 8.64287 16.197 8.74112L14.467
      9.3172C14.0867 9.44401 13.7411 9.65765 13.4577 9.9412C13.1744 10.2247 12.9609
      10.5704 12.8343 10.9508L12.2582 12.6799C12.237 12.7445 12.196 12.8007 12.141
      12.8405C12.086 12.8804 12.0198 12.9018 11.9519 12.9018C11.8839 12.9018 11.8177
      12.8804 11.7627 12.8405C11.7077 12.8007 11.6667 12.7445 11.6455 12.6799L11.0694
      10.9499C10.9427 10.5697 10.7292 10.2242 10.4458 9.94081C10.1624 9.65742 9.81695
      9.44392 9.43674 9.3172L7.7067 8.74112C7.64216 8.71994 7.58596 8.67891 7.54611
      8.6239C7.50627 8.56888 7.48481 8.50269 7.48481 8.43476C7.48481 8.36684 7.50627
      8.30064 7.54611 8.24563C7.58596 8.19062 7.64216 8.14959 7.7067 8.12841L9.43674
      7.55233C9.81695 7.42561 10.1624 7.21211 10.4458 6.92872C10.7292 6.64533 10.9427
      6.29985 11.0694 5.91964L11.6455 4.1896ZM8.20467 0.13289C8.21748 0.0942114 8.24215
      0.0605528 8.27518 0.0366966C8.30821 0.0128404 8.34792 0 8.38866 0C8.42941 0 8.46912
      0.0128404 8.50215 0.0366966C8.53518 0.0605528 8.55985 0.0942114 8.57265
      0.13289L8.91831 1.17074C9.07282 1.63339 9.43544 1.99601 9.8981 2.15053L10.9359
      2.49618C10.9746 2.50899 11.0083 2.53366 11.0321 2.56669C11.056 2.59972 11.0688
      2.63943 11.0688 2.68017C11.0688 2.72091 11.056 2.76062 11.0321 2.79365C11.0083
      2.82668 10.9746 2.85135 10.9359 2.86416L9.8981 3.20981C9.66992 3.28583 9.46258
      3.41395 9.29251 3.58402C9.12245 3.75409 8.99433 3.96142 8.91831 4.1896L8.57265
      5.22745C8.55985 5.26613 8.53518 5.29979 8.50215 5.32364C8.46912 5.3475 8.42941
      5.36034 8.38866 5.36034C8.34792 5.36034 8.30821 5.3475 8.27518 5.32364C8.24215
      5.29979 8.21748 5.26613 8.20467 5.22745L7.85902 4.1896C7.783 3.96142 7.65488
      3.75409 7.48481 3.58402C7.31475 3.41395 7.10741 3.28583 6.87923 3.20981L5.84139
      2.86416C5.80271 2.85135 5.76905 2.82668 5.74519 2.79365C5.72134 2.76062 5.7085
      2.72091 5.7085 2.68017C5.7085 2.63943 5.72134 2.59972 5.74519 2.56669C5.76905
      2.53366 5.80271 2.50899 5.84139 2.49618L6.87923 2.15053C7.10741 2.07451
      7.31475 1.94639 7.48481 1.77632C7.65488 1.60625 7.783 1.39892 7.85902 1.17074L8.20467
      0.13289ZM14.3902 0.519201C14.399 0.493769 14.4156 0.471717 14.4375 0.45611C14.4594
      0.440502 14.4857 0.432116 14.5126 0.432116C14.5395 0.432116 14.5658 0.440502
      14.5877 0.45611C14.6096 0.471717 14.6261 0.493769 14.6349 0.519201L14.8654
      1.2105C14.9681 1.51953 15.2101 1.76158 15.5192 1.86429L16.2105 2.09473C16.2359
      2.10354 16.258 2.12006 16.2736 2.14199C16.2892 2.16392 16.2976 2.19017 16.2976
      2.21709C16.2976 2.24401 16.2892 2.27025 16.2736 2.29218C16.258 2.31411 16.2359
      2.33063 16.2105 2.33945L15.5192 2.56989C15.3669 2.62055 15.2285 2.70602 15.115
      2.81951C15.0015 2.933 14.916 3.07138 14.8654 3.22367L14.6349 3.91498C14.6261
      3.94041 14.6096 3.96246 14.5877 3.97807C14.5658 3.99367 14.5395 4.00206 14.5126
      4.00206C14.4857 4.00206 14.4594 3.99367 14.4375 3.97807C14.4156 3.96246 14.399
      3.94041 14.3902 3.91498L14.1598 3.22367C14.1091 3.07138 14.0237 2.933 13.9102
      2.81951C13.7967 2.70602 13.6583 2.62055 13.506 2.56989L12.8156 2.33945C12.7902
      2.33063 12.7681 2.31411 12.7525 2.29218C12.7369 2.27025 12.7285 2.24401 12.7285
      2.21709C12.7285 2.19017 12.7369 2.16392 12.7525 2.14199C12.7681 2.12006 12.7902
      2.10354 12.8156 2.09473L13.5069 1.86429C13.8159 1.76158 14.058 1.51953 14.1607 1.2105L14.3902 0.519201Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="4"
      mask="url(#path-2-inside-1_9001_114691)"
    />
  </svg>
</template>
